import Globals from "./Globals";
import { qreq } from "./qrequest";

class SharedUtilClass {
    downloadProgressReport(orderID, visitID) {
        if(!visitID) visitID = '0';
        let url = Globals.serverUrl + '/api/report/wound/status/pdf/' + orderID + '/' + visitID + '/progress-report-' + orderID + '.pdf?timezone=' + Globals.getTimeZoneForQuery();
        if(Globals.isIOS()) {
            url += '?downloadOnly=true';
            window.location.href = url;
        }
        else
            window.open(url);
    }

    async progressReportAvailableAsync(orderID, visitID) {
        if(!visitID) visitID = '0';
        return new Promise(async (resolve, reject) => {
            try {
                let j = await qreq.getAsync('/api/report/wound/status/available/' + orderID + '/' + visitID);

                if (j.errorCode === 0)
                    resolve(true);
                else
                    resolve(false);
            }
            catch (e) {
                console.error(e);
                reject('Unknown error.');
            }
        });
    }
}

const SharedUtil = new SharedUtilClass();

export default SharedUtil;